export const toHexCode = (code?: string) => {
  return code?.toUpperCase().replace(/[^0-9A-F]/i, '');
};
// convert shorthand hex code to regular
export const toRegular = (code?: string) => {
  if (!code) return '';
  const has_hash = code.startsWith('#');
  const hex = toHexCode(code)?.substring(0, 6);
  const trimmed_hex =
    hex && hex.length < 6 ? hex.replace(/^([0-9A-F]){1}([0-9A-F]){1}([0-9A-F]){1}$/i, '$1$1$2$2$3$3') : hex;
  return (has_hash ? '#' : '') + trimmed_hex;
};
export const alphaToHex = (alpha?: number) => {
  const a = alpha && alpha > -1 ? alpha : 1;
  return a === 1 ? '' : ((a * 255) | (1 << 8)).toString(16).slice(1);
};
export const removeAlpha = (code: string) => {
  if (!code) return '';
  const has_hash = code.startsWith('#');
  const number = code.replace('#', '');
  const trimmed_number = number.length === 8 ? number.slice(0, 6) : number;
  return (has_hash ? '#' : '') + trimmed_number;
};
